"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BookOutline_exports = {};
__export(BookOutline_exports, {
  default: () => BookOutline_default
});
module.exports = __toCommonJS(BookOutline_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.4766 2.75C16.6719 2.75 16.8346 2.8151 16.9648 2.94531C17.0951 3.07552 17.1602 3.23828 17.1602 3.43359V17.0664C17.1602 17.2617 17.0951 17.4245 16.9648 17.5547C16.8346 17.6849 16.6719 17.75 16.4766 17.75H7.10156C6.42448 17.75 5.84505 17.5156 5.36328 17.0469C4.89453 16.5781 4.66016 16.0182 4.66016 15.3672V5.13281C4.66016 4.48177 4.89453 3.92188 5.36328 3.45312C5.84505 2.98438 6.42448 2.75 7.10156 2.75H16.4766ZM15.7734 14.332H7.10156C6.8151 14.332 6.56771 14.4362 6.35938 14.6445C6.15104 14.8398 6.04688 15.0807 6.04688 15.3672C6.04688 15.6536 6.15104 15.8945 6.35938 16.0898C6.56771 16.2852 6.8151 16.3828 7.10156 16.3828H15.7734V14.332ZM15.7734 4.11719H7.10156C6.8151 4.11719 6.56771 4.21484 6.35938 4.41016C6.15104 4.60547 6.04688 4.84635 6.04688 5.13281V13.1992C6.21615 13.1341 6.38542 13.082 6.55469 13.043C6.72396 13.0039 6.90625 12.9844 7.10156 12.9844H15.7734V4.11719Z",
      fill: "currentColor"
    }
  )
);
const SvgBookOutline = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var BookOutline_default = SvgBookOutline;
